import React from 'react'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'LuxKit/Typography/BodyText'
import Plural from 'components/utils/Formatters/Plural'
import Sheet from 'components/utils/Sheet'
import FlashHotelMobileRateOption from '../SameRoom/FlashHotelMobileRateOption'

interface Props {
  packageViews: Array<App.OfferPackageOptionView>
}

function FlashHotelPackageOptionsModalTab(props: Props) {
  const { packageViews } = props

  return (
    <Pane background="neutral-six">
      {packageViews.length > 1 && (
        <Pane background="neutral-eight" padding="12 20">
          <BodyText variant="small" colour="neutral-three">
            <Plural singular="package option" count={packageViews.length} withCount /> available
          </BodyText>
        </Pane>
      )}
      <Group direction="vertical" gap={8}>
        {packageViews.map((view, index) => (
          <Sheet key={view.package.uniqueKey} border="neutral-six">
            <FlashHotelMobileRateOption
              packageView={view}
              packagePosition={packageViews.length > 1 ? index + 1 : undefined}
            />
          </Sheet>
        ))}
      </Group>
    </Pane>
  )
}

export default FlashHotelPackageOptionsModalTab
